import Vue, { VueConstructor } from 'vue'

const SimpleRules = {
  install(vue: VueConstructor) {
    vue.prototype.$rules = {
      required(v: any) {
        return !!v || 'Este campo no puede estar vacío'
      },
      requiredCustom(message: string) {
        return function (v: any) {
          return !!v || message
        }
      },
      isEmail(v: string) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(v).toLowerCase()) || 'El valor ingresado no es un email'
      },
      isChannelID(v: string) {
        if (!v) return true
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(v).toLowerCase()) || 'El valor ingresado no es un ID válido'
      },
      isSingleWord(v: string) {
        return (!!v && v.split(' ').length === 1) || 'Este campo debe contener solo una palabra'
      },
      isHttps(v: string) {
        return v.startsWith('https://') || 'La url debe contener un formato válido'
      },
      isDeeplink(v: string) {
        return (
          (v.includes('://') && !v.startsWith('://') && !v.endsWith('://')) ||
          'El deeplink debe contener un formato válido'
        )
      },
      minLength(length: number) {
        return function (v: string) {
          return (!!v && v.length >= length) || 'El campo no tiene el mínimo de carácteres'
        }
      },
      maxLength(length: number) {
        return function (v: string) {
          return (!!v && v.length <= length) || 'El campo excede el máximo de carácteres'
        }
      },
      minValue(value: number) {
        return function (v: number) {
          return (!!v && v > value) || 'El valor debe ser mayor a ' + value
        }
      },
      minTimeValue(value: number) {
        return function (v: number) {
          return (!!v && v >= value) || 'El valor debe ser mayor o igual a ' + value
        }
      },
      maxValue(value: number) {
        return function (v: number) {
          return (!!v && v < value) || 'El valor debe ser menor a ' + value
        }
      },
      isVideoMp4(v: string) {
        return (
          (v.endsWith('.mp4') && v.startsWith('https://')) ||
          'La url debe contener un formato válido y el formato del vídeo en mp4'
        )
      },
      isURL(v: string) {
        if (!v) return true
        const pattern = new RegExp(
          '^(https?:\\/\\/)?' +
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
            '((\\d{1,3}\\.){3}\\d{1,3}))|' +
            'localhost' +
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
            '(\\?[;&a-z\\d%_.~+=-]*)?' +
            '(\\#[-a-z\\d_]*)?$',
          'i'
        )
        return pattern.test(v) || 'El campo no es una URL válida'
      },
      atLeastOneLowerCase(v: string) {
        return (!!v && /.*[a-z].*/g.test(v)) || 'Debe tener al menos una letra minúscula'
      },
      atLeastOneUpperCase(v: string) {
        return (!!v && /.*[A-Z].*/g.test(v)) || 'Debe tener al menos una letra mayúscula'
      },
      atLeastOneNumber(v: string) {
        return (!!v && /.*[0-9].*/g.test(v)) || 'Debe tener al menos un número'
      }
    }
  }
}

Vue.use(SimpleRules)
